export const isAdminRole = (role) => role === "admin";

export const getEffectiveRole = (decodedRole, userRole) => {
  if (decodedRole === "admin" || userRole === "admin") return "admin";
  if (decodedRole === "clubAdmin" || userRole === "clubAdmin") {
    return "clubAdmin";
  }
  if (decodedRole === "sponsor" || userRole === "sponsor") return "sponsor";
  return decodedRole || userRole || "";
};
